module.exports = {"content":"Footer"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.json
// module id = 878
// module chunks = 114276838955818